import React, { useEffect, useState, createElement, Component } from 'react';
import { CheckIcon, Volume2Icon, PlayIcon, XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function JosephWellPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    // Meta tag
    const meta = document.createElement('meta');
    meta.httpEquiv = 'delegate-ch';
    meta.content = 'sec-ch-ua https://trk.adsdomredir.com; sec-ch-ua-mobile https://trk.adsdomredir.com; sec-ch-ua-arch https://trk.adsdomredir.com; sec-ch-ua-model https://trk.adsdomredir.com; sec-ch-ua-platform https://trk.adsdomredir.com; sec-ch-ua-platform-version https://trk.adsdomredir.com; sec-ch-ua-bitness https://trk.adsdomredir.com; sec-ch-ua-full-version-list https://trk.adsdomredir.com; sec-ch-ua-full-version https://trk.adsdomredir.com';
    document.head.appendChild(meta);
    // Style
    const style = document.createElement('style');
    style.textContent = '.dtpcnt{opacity: 0;}';
    document.head.appendChild(style);
    // Script
    const script = document.createElement('script');
    script.textContent = `(function(e,d,k,n,u,v,g,w,C,f,p,x,D,c,q,r,h,t,y,G,z){function A(){for(var a=d.querySelectorAll(".dtpcnt"),b=0,l=a.length;b<l;b++)a[b][w]=a[b][w].replace(/(^|\\s+)dtpcnt($|\\s+)/g,"")}function E(a,b,l,F){var m=new Date;m.setTime(m.getTime()+(F||864E5));d.cookie=a+"="+b+"; "+l+"samesite=Strict; expires="+m.toGMTString()+"; path=/";k.setItem(a,b);k.setItem(a+"-expires",m.getTime())}function B(a){var b=d.cookie.match(new RegExp("(^| )"+a+"=([^;]+)"));return b?b.pop():k.getItem(a+"-expires")&&+k.getItem(a+"-expires")>(new Date).getTime()?k.getItem(a):null}z="https:"===e.location.protocol?"secure; ":"";e[f]||(e[f]=function(){(e[f].q=e[f].q||[]).push(arguments)},r=d[u],d[u]=function(){r&&r.apply(this,arguments);if(e[f]&&!e[f].hasOwnProperty("params")&&/loaded|interactive|complete/.test(d.readyState))for(;c=d[v][p++];)/\\/?click\\/?($|(\\/[0-9]+)?$)/.test(c.pathname)&&(c[g]="javascrip"+e.postMessage.toString().slice(4,5)+":"+f+'.l="'+c[g]+'",void 0')},setTimeout(function(){(t=RegExp("[?&]cpid(=([^&#]*)|&|#|$)").exec(e.location.href))&&t[2]&&(h=t[2],y=B("vl-"+h));var a=B("vl-cep"),b=location[g];if("savedCep"===D&&a&&(!h||"undefined"===typeof h)&&0>b.indexOf("cep=")){var l=-1<b.indexOf("?")?"&":"?";b+=l+a}c=d.createElement("script");q=d.scripts[0];c.defer=1;c.src=x+(-1===x.indexOf("?")?"?":"&")+"lpref="+n(d.referrer)+"&lpurl="+n(b)+"&lpt="+n(d.title)+"&vtm="+(new Date).getTime()+(y?"&uw=no":"");c[C]=function(){for(p=0;c=d[v][p++];)/dtpCallback\\.l/.test(c[g])&&(c[g]=decodeURIComponent(c[g]).match(/dtpCallback\\.l="([^"]+)/)[1]);A()};q.parentNode.insertBefore(c,q);h&&E("vl-"+h,"1",z)},0),setTimeout(A,7E3))})(window,document,localStorage,encodeURIComponent,"onreadystatechange","links","href","className","onerror","dtpCallback",0,"https://trk.adsdomredir.com/d/.js","savedCep");`;
    document.head.appendChild(script);
    // Noscript
    const noscript = document.createElement('noscript');
    const link = document.createElement('link');
    link.href = 'https://trk.adsdomredir.com/d/.js?noscript=true&lpurl=';
    link.rel = 'stylesheet';
    noscript.appendChild(link);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(meta);
      document.head.removeChild(style);
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-black selection:bg-red-600 selection:text-white pb-12" data-id="element-366">
      <main className="max-w-[800px] mx-auto px-4 sm:px-6 pt-8 sm:pt-12 flex flex-col items-center text-center" data-id="element-367">
        {/* Headline */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight leading-[1.1] mb-6" data-id="element-368">
          <span className="text-[#d92027] block drop-shadow-sm" data-id="element-369">
            Our Well Dried Up
          </span>
          <span className="block mt-2 drop-shadow-sm" data-id="element-370">But God Gave Us</span>
          <span className="block mt-2 underline decoration-4 underline-offset-8 drop-shadow-sm" data-id="element-371">
            This Solution
          </span>
        </h1>

        {/* Subheadline */}
        <div className="text-lg sm:text-xl md:text-2xl font-medium mb-8 space-y-2" data-id="element-372">
          <p data-id="element-373">No pipes. No grid. No begging for help.</p>
          <p data-id="element-374">
            Just 40+ gallons a day of clean, drinkable water... pulled straight
            from the air.
          </p>
        </div>

        {/* Video Placeholder */}
        <a href="https://trk.adsdomredir.com/click" className="block w-full" data-id="element-375">
          <div className="relative w-full aspect-video bg-black rounded-sm overflow-hidden shadow-2xl mb-6 group cursor-pointer border-4 border-gray-200" data-id="element-376">
            <img src="https://images.unsplash.com/photo-1538300342682-cf57afb97285?q=80&w=2574&auto=format&fit=crop" alt="Video thumbnail" className="w-full h-full object-cover opacity-80" data-id="element-377" />

            {/* Top Text */}
            <div className="absolute top-4 left-0 w-full text-center" data-id="element-378">
              <span className="bg-black/60 text-yellow-400 font-bold text-xl sm:text-3xl px-4 py-1 rounded" data-id="element-379">
                Generate Water-On-Demand
              </span>
            </div>

            {/* Play Button */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-380">
              <div className="w-24 h-24 sm:w-32 sm:h-32 bg-[#d92027]/90 rounded-full flex items-center justify-center shadow-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-381">
                <PlayIcon className="w-12 h-12 sm:w-16 sm:h-16 text-white fill-current ml-2" data-id="element-382" />
              </div>
            </div>

            {/* Bottom Text */}
            <div className="absolute bottom-4 left-0 w-full text-center" data-id="element-383">
              <span className="bg-black/60 text-yellow-400 font-bold text-lg sm:text-2xl px-4 py-1 rounded" data-id="element-384">
                Click To Watch The Free Presentation
              </span>
            </div>

            {/* Sound Icon */}
            <div className="absolute bottom-4 left-4 bg-white/90 rounded-full px-3 py-1.5 flex items-center gap-2 shadow-lg animate-pulse" data-id="element-385">
              <div className="bg-[#d92027] rounded-full p-1" data-id="element-386">
                <Volume2Icon className="w-5 h-5 text-white" data-id="element-387" />
              </div>
              <div className="text-left leading-tight" data-id="element-388">
                <div className="text-[10px] font-bold text-gray-600 uppercase" data-id="element-389">
                  Click To Turn
                </div>
                <div className="text-sm font-black text-black uppercase" data-id="element-390">
                  On Sound
                </div>
              </div>
            </div>
          </div>
        </a>
        {/* Under Video Text */}
        <p className="text-sm sm:text-base font-medium max-w-2xl mb-8" data-id="element-391">
          Built for under $150 with simple tools and now revealed to help other
          families prepare <span className="italic" data-id="element-392">before it's too late</span>.
        </p>

        {/* CTA 1 */}
        <div className="w-full max-w-md mb-4" data-id="element-393">
          <a href="https://trk.adsdomredir.com/click" className="block w-full bg-[#f97316] hover:bg-[#ea580c] text-black font-black text-xl sm:text-2xl py-4 px-6 rounded shadow-[0_4px_0_#c2410c] active:shadow-[0_0px_0_#c2410c] active:translate-y-1 transition-all text-center leading-tight" data-id="element-394">
            WATCH IT BEFORE IT
            <br data-id="element-395" />
            DISAPPEARS... AGAIN!
          </a>
        </div>
        <p className="text-xs sm:text-sm mb-12" data-id="element-396">
          Click Here to See the Water System That's Helping Christian Families
          Prepare
        </p>

        {/* Section Title */}
        <h2 className="text-2xl sm:text-3xl font-bold mb-6 leading-tight" data-id="element-397">
          The Faith-Powered Water Breakthrough That Pulled 40+ Gallons a Day
          From <span className="underline" data-id="element-398">Thin Air</span>
        </h2>

        {/* Body Text */}
        <div className="text-sm sm:text-base space-y-4 mb-8 max-w-2xl" data-id="element-399">
          <p data-id="element-400">
            This isn't science fiction. It's a God-given solution built by a man
            of faith who refused to let his family go without clean water.
          </p>
          <p data-id="element-401">After his well dried up, he created a system that:</p>

          <ul className="text-left inline-block space-y-2 font-medium mx-auto" data-id="element-402">
            <li className="flex items-start gap-2" data-id="element-403">
              <div className="bg-green-500 rounded-sm p-0.5 mt-0.5 flex-shrink-0" data-id="element-404">
                <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-405" />
              </div>
              <span data-id="element-406">
                Pulls water straight from the air (even in the desert)
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-407">
              <div className="bg-green-500 rounded-sm p-0.5 mt-0.5 flex-shrink-0" data-id="element-408">
                <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-409" />
              </div>
              <span data-id="element-410">
                Runs quietly — no pipes, no drilling, no attention drawn
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-411">
              <div className="bg-green-500 rounded-sm p-0.5 mt-0.5 flex-shrink-0" data-id="element-412">
                <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-413" />
              </div>
              <span data-id="element-414">Works on-grid or fully off-grid (solar compatible)</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-415">
              <div className="bg-green-500 rounded-sm p-0.5 mt-0.5 flex-shrink-0" data-id="element-416">
                <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-417" />
              </div>
              <span data-id="element-418">
                Costs under $150 using parts from a local hardware store
              </span>
            </li>
          </ul>

          <p className="pt-2" data-id="element-419">
            And now he's revealing how you can build it, too.
          </p>
          <p data-id="element-420">
            If you have a family to protect — this may be the most important
            system you'll ever own.
          </p>
          <p className="font-bold text-yellow-600 flex items-center justify-center gap-2" data-id="element-421">
            <span className="text-xl" data-id="element-422">⚠️</span> Watch the video now before it's
            removed again.
          </p>
        </div>

        {/* CTA 2 */}
        <div className="w-full max-w-md mb-2" data-id="element-423">
          
        </div>
        <p className="text-xs sm:text-sm mb-12" data-id="element-424">Click to Watch Now</p>

        {/* Testimonials */}
        <div className="w-full max-w-2xl space-y-10 mb-12" data-id="element-425">
          {/* Testimonial 1 */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-left" data-id="element-426">
            <img src="https://cdn.magicpatterns.com/uploads/w8EZc7gyde547A9pTA1yLp/imtest1b.jpg" alt="Mark T." className="w-32 h-32 rounded-full object-cover shadow-md flex-shrink-0" data-id="element-427" />
            <div className="space-y-2 text-center sm:text-left" data-id="element-428">
              <h4 className="font-bold text-lg" data-id="element-429">
                I'm no handyman but I built it in two days.
              </h4>
              <p className="text-sm italic" data-id="element-430">
                "I built Joseph's Well in just two days using parts from the
                local hardware store. I'm no handyman, but it works. Now we have
                clean water every single morning. No stress. Just peace."
              </p>
              <p className="text-sm font-medium" data-id="element-431">— Mark T., Kentucky</p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-left" data-id="element-432">
            <img src="https://cdn.magicpatterns.com/uploads/nr3939x58vAuaKmQRHChno/imtest2b.jpg" alt="Jason M." className="w-32 h-32 rounded-full object-cover shadow-md flex-shrink-0" data-id="element-433" />
            <div className="space-y-2 text-center sm:text-left" data-id="element-434">
              <h4 className="font-bold text-lg" data-id="element-435">
                When John spoke, I knew it came from the Lord.
              </h4>
              <p className="text-sm italic" data-id="element-436">
                "I've known John for 15 years. When he told me about this
                system, I knew it came from the Lord. I followed his guide and
                built one behind my workshop. It works — and it's changed how I
                prepare."
              </p>
              <p className="text-sm font-medium" data-id="element-437">— Jason M., Montana</p>
            </div>
          </div>
        </div>

        {/* CTA 3 */}
        <div className="w-full max-w-md mb-2" data-id="element-438">
          
        </div>
        <p className="text-xs sm:text-sm mb-12" data-id="element-439">(100% free to watch)</p>

        {/* More Testimonials */}
        <div className="w-full max-w-2xl space-y-10 mb-12" data-id="element-440">
          {/* Testimonial 3 */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-left" data-id="element-441">
            <img src="https://cdn.magicpatterns.com/uploads/1h6CD8ixdMmFwy4e5Hhfsg/imtest3b.jpg" alt="Carlos D." className="w-32 h-32 rounded-full object-cover shadow-md flex-shrink-0" data-id="element-442" />
            <div className="space-y-2 text-center sm:text-left" data-id="element-443">
              <h4 className="font-bold text-lg" data-id="element-444">
                I didn't think it would work. But now I'm a believer.
              </h4>
              <p className="text-sm italic" data-id="element-445">
                "Honestly, I didn't think it would work. But it does. I haven't
                bought bottled water in over a month, and I sleep better knowing
                we're covered no matter what."
              </p>
              <p className="text-sm font-medium" data-id="element-446">— Carlos D., California</p>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-left" data-id="element-447">
            <img src="https://cdn.magicpatterns.com/uploads/gU9ocVHcwugXatHuSHHsT9/imtest4b.jpg" alt="Derek" className="w-32 h-32 rounded-full object-cover shadow-md flex-shrink-0" data-id="element-448" />
            <div className="space-y-2 text-center sm:text-left" data-id="element-449">
              <h4 className="font-bold text-lg" data-id="element-450">
                Off-grid water. No stress. No more dependence.
              </h4>
              <p className="text-sm italic" data-id="element-451">
                "I'm a father, not an engineer. But now our fridge, lights, and
                water are off-grid. That's freedom — and it started with
                Joseph's Well."
              </p>
              <p className="text-sm font-medium" data-id="element-452">— Derek, Pennsylvania</p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="w-full max-w-md mb-2" data-id="element-453">
          <a href="https://trk.adsdomredir.com/click" className="block w-full bg-[#f97316] hover:bg-[#ea580c] text-black font-black text-xl py-3 px-6 rounded shadow-[0_4px_0_#c2410c] active:shadow-[0_0px_0_#c2410c] active:translate-y-1 transition-all text-center leading-tight" data-id="element-454">
            WATCH IT BEFORE IT
            <br data-id="element-455" />
            DISAPPEARS... AGAIN!
          </a>
        </div>
        <p className="text-xs sm:text-sm mb-16" data-id="element-456">(100% free to watch)</p>

        {/* Footer */}
        <footer className="w-full border-t border-black pt-8 text-xs text-blue-600 space-y-4" data-id="element-457">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4" data-id="element-458">
            <button onClick={() => setActiveModal('privacy')} className="hover:underline cursor-pointer text-blue-600" data-id="element-459">
              Privacy Policy
            </button>
            <span className="text-black" data-id="element-460">|</span>
            <button onClick={() => setActiveModal('terms')} className="hover:underline cursor-pointer text-blue-600" data-id="element-461">
              Terms of Service
            </button>
          </div>

          <p className="text-black" data-id="element-462">
            © 2026 PatriotsInformer | All Rights Reserved
          </p>

          <p className="text-[10px] text-gray-500 max-w-xl mx-auto leading-tight" data-id="element-463">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, this site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </footer>
      </main>

      {/* Modals */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-464">
          <div className="absolute inset-0 bg-black/50" data-id="element-465" />
          <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-466">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-467">
              <h2 className="text-lg font-bold text-[#0f172a]" data-id="element-468">
                {activeModal === 'privacy' && 'Privacy Policy'}
                {activeModal === 'terms' && 'Terms of Service'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors" data-id="element-469">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-470" />
              </button>
            </div>

            <div className="px-6 py-6 text-sm text-[#334155] leading-relaxed space-y-4 text-left" data-id="element-471">
              {activeModal === 'privacy' && <>
                  <p className="font-semibold text-[#0f172a]" data-id="element-472">
                    Last Updated: March 2026
                  </p>
                  <p data-id="element-473">
                    This Privacy Policy describes how your personal information
                    is collected, used, and shared when you visit this website
                    (the "Site").
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-474">
                    1. Information We Collect
                  </h3>
                  <p data-id="element-475">
                    When you visit the Site, we automatically collect certain
                    information about your device, including information about
                    your web browser, IP address, time zone, and some of the
                    cookies that are installed on your device. Additionally, as
                    you browse the Site, we collect information about the
                    individual web pages that you view, what websites or search
                    terms referred you to the Site, and information about how
                    you interact with the Site.
                  </p>
                  <p data-id="element-476">
                    We may also collect personal information you voluntarily
                    provide, such as your name and email address when you
                    subscribe to a newsletter or fill out a form.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-477">
                    2. How We Use Your Information
                  </h3>
                  <p data-id="element-478">
                    We use the information we collect to: communicate with you
                    and provide you with information or content you have
                    requested; improve and optimize our Site; and monitor and
                    analyze usage and trends to improve your experience with the
                    Site.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-479">
                    3. Sharing Your Information
                  </h3>
                  <p data-id="element-480">
                    We do not sell, trade, or rent your personal identification
                    information to others. We may share generic aggregated
                    demographic information not linked to any personal
                    identification information with our business partners and
                    trusted affiliates for the purposes outlined above.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-481">4. Cookies</h3>
                  <p data-id="element-482">
                    We use cookies and similar tracking technologies to track
                    activity on our Site and hold certain information. Cookies
                    are files with a small amount of data which may include an
                    anonymous unique identifier. You can instruct your browser
                    to refuse all cookies or to indicate when a cookie is being
                    sent.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-483">
                    5. Third-Party Services
                  </h3>
                  <p data-id="element-484">
                    We may employ third-party companies and individuals to
                    facilitate our Site, provide services on our behalf, perform
                    Site-related services, or assist us in analyzing how our
                    Site is used. These third parties have access to your
                    personal information only to perform these tasks on our
                    behalf and are obligated not to disclose or use it for any
                    other purpose.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-485">
                    6. Data Security
                  </h3>
                  <p data-id="element-486">
                    We implement reasonable security measures to protect your
                    personal information. However, no method of transmission
                    over the Internet or method of electronic storage is 100%
                    secure, and we cannot guarantee its absolute security.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-487">
                    7. Your Rights
                  </h3>
                  <p data-id="element-488">
                    You have the right to access the personal information we
                    hold about you and to ask that your personal information be
                    corrected, updated, or deleted. If you would like to
                    exercise this right, please contact us.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-489">
                    8. Changes to This Policy
                  </h3>
                  <p data-id="element-490">
                    We may update this Privacy Policy from time to time in order
                    to reflect changes to our practices or for other
                    operational, legal, or regulatory reasons. We encourage you
                    to review this page periodically for the latest information.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-491">
                    9. Contact Us
                  </h3>
                  <p data-id="element-492">
                    For more information about our privacy practices, if you
                    have questions, or if you would like to make a complaint,
                    please contact us by email at support@jacksdiyprojects.com.
                  </p>

                  <p className="pt-2 text-xs text-gray-400" data-id="element-493">
                    © 2026 All Rights Reserved.
                  </p>
                </>}

              {activeModal === 'terms' && <>
                  <p className="font-semibold text-[#0f172a]" data-id="element-494">
                    Last Updated: March 2026
                  </p>
                  <p data-id="element-495">
                    Please read these Terms of Service ("Terms") carefully
                    before using this website (the "Site"). By accessing or
                    using the Site, you agree to be bound by these Terms.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-496">
                    1. Acceptance of Terms
                  </h3>
                  <p data-id="element-497">
                    By accessing this website, you acknowledge that you have
                    read, understood, and agree to be bound by these Terms of
                    Service. If you do not agree to these Terms, please do not
                    use this website.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-498">
                    2. Use of Content
                  </h3>
                  <p data-id="element-499">
                    All content on this website, including text, graphics,
                    images, videos, and other material, is for informational and
                    educational purposes only. No part of this content may be
                    reproduced, distributed, or transmitted in any form without
                    prior written permission from the publisher.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-500">
                    3. Disclaimer of Warranties
                  </h3>
                  <p data-id="element-501">
                    The information provided on this Site is presented "as is"
                    without any representations or warranties, express or
                    implied. We make no representations or warranties in
                    relation to the information on this website. The content is
                    not intended as professional advice. Always consult
                    qualified professionals for specific guidance.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-502">
                    4. Earnings Disclaimer
                  </h3>
                  <p data-id="element-503">
                    Any earnings or income statements, or earnings or income
                    examples, are only estimates of what we think you could
                    potentially earn. There is no assurance you'll do as well.
                    If you rely upon our figures, you must accept the risk of
                    not doing as well. Any claims made of actual earnings or
                    examples of actual results can be verified upon request.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-504">
                    5. Product Representations
                  </h3>
                  <p data-id="element-505">
                    Results described on this Site are not typical and may vary
                    from person to person. The products and information provided
                    are for educational purposes and should not be considered as
                    a guarantee of specific results. Individual results will
                    vary based on effort, experience, and other factors.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-506">
                    6. Limitation of Liability
                  </h3>
                  <p data-id="element-507">
                    In no event shall we be liable for any direct, indirect,
                    incidental, special, consequential, or punitive damages
                    arising out of or in connection with your use of the Site,
                    whether based on warranty, contract, tort, or any other
                    legal theory, and whether or not we have been advised of the
                    possibility of such damages.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-508">
                    7. External Links
                  </h3>
                  <p data-id="element-509">
                    This Site may contain links to external websites that are
                    not provided or maintained by us. We do not guarantee the
                    accuracy, relevance, timeliness, or completeness of any
                    information on these external websites. We are not
                    responsible for the content or practices of any third-party
                    websites.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-510">
                    8. Affiliate Disclosure
                  </h3>
                  <p data-id="element-511">
                    This Site may contain affiliate links. This means we may
                    earn a commission if you click on a link and make a
                    purchase. This comes at no additional cost to you. We only
                    recommend products and services that we believe will add
                    value to our readers.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-512">
                    9. Modifications to Terms
                  </h3>
                  <p data-id="element-513">
                    We reserve the right to modify these Terms at any time.
                    Changes will be effective immediately upon posting to the
                    Site. Your continued use of the Site after any changes
                    constitutes your acceptance of the new Terms.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-514">
                    10. Governing Law
                  </h3>
                  <p data-id="element-515">
                    These Terms shall be governed by and construed in accordance
                    with the laws of the United States, without regard to
                    conflict of law provisions.
                  </p>

                  <h3 className="font-bold text-[#0f172a] pt-2" data-id="element-516">
                    11. Contact Us
                  </h3>
                  <p data-id="element-517">
                    If you have any questions about these Terms, please contact
                    us at support@jacksdiyprojects.com.
                  </p>

                  <p className="pt-2 text-xs text-gray-400" data-id="element-518">
                    © 2026 All Rights Reserved.
                  </p>
                </>}
            </div>
          </div>
        </div>}
    </div>;
}